import React, { Component } from "react";
import { Button, Form, Col } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import config from "../../../config";
import moment from "moment";
import { GetMccList, UpdateMccRecord } from "../../../api";
import "./merchant-info.scss";
import SelectDropDown from "../drop-down/drop-down";

const MAIN_URL = config.paymentcloud.MAIN_URL;

export default class MerchantInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show_spinner: false,
            appData: {
                ...this.props.appData,
            },
            message: "",
        };
    }
    componentDidMount() {}
    PricingLabel = (type) => {
        switch (type) {
            case "icppt":
                return "IC Plus / Pass-Through";
                break;
            case "tiered":
                return "Tiered";
                break;
            case "sccd":
                return "Surcharge / Cash Discount";
                break;
            default:
                return "";
                break;
        }
    };
    render() {
        const { accordionNumber } = this.props;
        const { show_spinner, appData } = this.state;
        return (
            <>
                {show_spinner ? (
                    <div className="spinner">
                        <Loader />
                    </div>
                ) : (
                    ""
                )}
                {this.props.sendToService ? (
                    <div className="row mcc-box">
                        <div>
                            <label>MCC</label>
                            <p className="form-control-static">
                                {appData.mcc_info ? (
                                    appData.mcc_info.description
                                ) : (
                                    <>&mdash;</>
                                )}
                            </p>

                            {this.state.message ? (
                                <p className="text-primary">
                                    * {this.state.message}
                                </p>
                            ) : null}
                        </div>
                    </div>
                ) : null}
                <Accordion defaultActiveKey="0">
                    <Card>
                        <Card.Header
                            className={accordionNumber === 0 ? "opened" : ""}
                        >
                            <Accordion.Toggle
                                as={Button}
                                variant="link"
                                eventKey="0"
                                onClick={() => this.handleToggleAccordion(0)}
                            >
                                Personal{" "}
                                <i
                                    className={
                                        accordionNumber === 0
                                            ? "fa fa-chevron-up"
                                            : "fa fa-chevron-down"
                                    }
                                />
                            </Accordion.Toggle>
                        </Card.Header>
                        <Accordion.Collapse eventKey="0">
                            <Card.Body>
                                <span className="separator" />
                                <div className="relevent-info-box">
                                    <div className="relevent-infos">
                                        <div className="row">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group">
                                                    <label>First Name</label>
                                                    <p className="form-control-static">
                                                        {appData.field_firstname || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>Last Name</label>
                                                    <p className="form-control-static">
                                                        {appData.field_lastname &&
                                                        appData.field_lastname.toLowerCase() !==
                                                            "placeholder" ? (
                                                            appData.field_lastname
                                                        ) : (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>Date of Birth</label>
                                                    <p className="form-control-static">
                                                        {appData.field_birthdate &&
                                                        appData.field_birthdate !==
                                                            "1970-01-01 00:00:00" ? (
                                                            moment(
                                                                appData.field_birthdate,
                                                            ).format("MMMM D Y")
                                                        ) : (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>Home Address</label>
                                                    <p className="form-control-static">
                                                        {appData.field_personalstreet || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>City</label>
                                                    <p className="form-control-static">
                                                        {appData.field_personalcity || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>State</label>
                                                    <p className="form-control-static">
                                                        {appData.field_personalstate || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>Zip Code</label>
                                                    <p className="form-control-static">
                                                        {appData.field_personalzip || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group">
                                                    <label>
                                                        Time at current
                                                        residence(years)
                                                    </label>
                                                    <p className="form-control-static">
                                                        {appData.field_residenceyears || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>
                                                        Time at current
                                                        residence(months)
                                                    </label>
                                                    <p className="form-control-static">
                                                        {appData.field_residencemonths || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>
                                                        Social security
                                                    </label>
                                                    <p className="form-control-static">
                                                        {appData.field_socialsecurity || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>
                                                        {appData.field_documenttype ==
                                                        "PASSPORT"
                                                            ? "Passport Number"
                                                            : "Drivers License"}{" "}
                                                    </label>
                                                    <p className="form-control-static">
                                                        {appData.field_documentnumber || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                {appData.field_documenttype ==
                                                "STATE_ID" ? (
                                                    <div className="form-group">
                                                        <label>
                                                            Drivers License
                                                            (state)
                                                        </label>
                                                        <p className="form-control-static">
                                                            {appData.field_driverstate || (
                                                                <>&mdash;</>
                                                            )}
                                                        </p>
                                                    </div>
                                                ) : (
                                                    <></>
                                                )}
                                                <div className="form-group">
                                                    <label>
                                                        Personal Phone
                                                    </label>
                                                    <p className="form-control-static">
                                                        {appData.field_personalphone || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>Email Id</label>
                                                    <p className="form-control-static">
                                                        {appData.field_email || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Card.Header
                            className={accordionNumber === 1 ? "opened" : ""}
                        >
                            <Accordion.Toggle
                                as={Button}
                                variant="link"
                                eventKey="1"
                                onClick={() => this.handleToggleAccordion(1)}
                            >
                                Legal{" "}
                                <i
                                    className={
                                        accordionNumber === 1
                                            ? "fa fa-chevron-up"
                                            : "fa fa-chevron-down"
                                    }
                                />
                            </Accordion.Toggle>
                        </Card.Header>
                        <Accordion.Collapse eventKey="1">
                            <Card.Body>
                                <span className="separator" />
                                <div className="relevent-info-box">
                                    <div className="relevent-infos">
                                        <div className="row">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group">
                                                    <label>Legal Name</label>
                                                    <p className="form-control-static">
                                                        {appData.field_legalname || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>
                                                        Type of Ownership
                                                    </label>
                                                    <p className="form-control-static">
                                                        {appData.field_ownership || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>
                                                        Type of Business
                                                    </label>
                                                    <p className="form-control-static">
                                                        {appData.powerappbusinessprofile ? (
                                                            appData
                                                                .powerappbusinessprofile
                                                                .product_service_sold
                                                        ) : (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>Legal Address</label>
                                                    <p className="form-control-static">
                                                        {appData.field_legalstreet || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>City</label>
                                                    <p className="form-control-static">
                                                        {appData.field_legalcity || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>State</label>
                                                    <p className="form-control-static">
                                                        {appData.field_legalstate || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>Zip Code</label>
                                                    <p className="form-control-static">
                                                        {appData.field_legalzip || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>DBA</label>
                                                    <p className="form-control-static">
                                                        {appData.field_dba || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>DBA Phone</label>
                                                    <p className="form-control-static">
                                                        {appData.field_dbaphone || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>DBA Address</label>
                                                    <p className="form-control-static">
                                                        {appData.field_dbastreet || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>DBA City</label>
                                                    <p className="form-control-static">
                                                        {appData.field_dbacity || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>DBA State</label>
                                                    <p className="form-control-static">
                                                        {appData.field_dbastate || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group">
                                                    <label>DBA Zip</label>
                                                    <p className="form-control-static">
                                                        {appData.field_dbazip || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>
                                                        Length at
                                                        location(years)
                                                    </label>
                                                    <p className="form-control-static">
                                                        {appData.field_locationyears || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>
                                                        Length at
                                                        location(months)
                                                    </label>
                                                    <p className="form-control-static">
                                                        {appData.field_locationmonths || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>
                                                        Business Phone
                                                    </label>
                                                    <p className="form-control-static">
                                                        {appData.field_businessphone || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>Tax ID/EIN</label>
                                                    <p className="form-control-static">
                                                        {appData.field_ein || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>
                                                        Business Email
                                                    </label>
                                                    <p className="form-control-static">
                                                        {appData.field_businessemail || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>
                                                        Website address
                                                    </label>
                                                    <p className="form-control-static">
                                                        {appData.field_website || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>
                                                        Length of
                                                        Ownership(years)
                                                    </label>
                                                    <p className="form-control-static">
                                                        {appData.field_ownershipyears || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>
                                                        Length of
                                                        Ownership(months)
                                                    </label>
                                                    <p className="form-control-static">
                                                        {appData.field_ownershipmonths || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>
                                                        Approximate Size: Square
                                                        Footage
                                                    </label>
                                                    <p className="form-control-static">
                                                        {appData.field_squarefootage || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="form-group">
                                                    <label>Zone</label>
                                                    <p className="form-control-static">
                                                        {appData.field_zone || (
                                                            <>&mdash;</>
                                                        )}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Card.Header
                            className={accordionNumber === 2 ? "opened" : ""}
                        >
                            <Accordion.Toggle
                                as={Button}
                                variant="link"
                                eventKey="2"
                                onClick={() => this.handleToggleAccordion(2)}
                            >
                                Business{" "}
                                <i
                                    className={
                                        accordionNumber === 2
                                            ? "fa fa-chevron-up"
                                            : "fa fa-chevron-down"
                                    }
                                />
                            </Accordion.Toggle>
                        </Card.Header>
                        <Accordion.Collapse eventKey="2">
                            <Card.Body>
                                {appData.powerappbusinessprofile ? (
                                    <div className="relevent-info-box">
                                        <h4 className="text-center">
                                            Business Info
                                        </h4>
                                        <div className="relevent-infos business-info ">
                                            <div className="row">
                                                <div className="col-md-12 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label>
                                                            Please describe in
                                                            detail the
                                                            products/services
                                                            sold.
                                                        </label>
                                                        <p className="form-control-static">
                                                            {appData
                                                                .powerappbusinessprofile
                                                                .product_service_sold || (
                                                                <>&mdash;</>
                                                            )}{" "}
                                                        </p>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>
                                                            How is the
                                                            product/service
                                                            ordered or
                                                            purchased? (i.e.
                                                            website, over the
                                                            phone, order
                                                            form/contract, etc.)
                                                        </label>
                                                        <p className="form-control-static">
                                                            {appData
                                                                .powerappbusinessprofile
                                                                .how_product_service_purchased || (
                                                                <>&mdash;</>
                                                            )}{" "}
                                                        </p>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>
                                                            At what time during
                                                            the ordering process
                                                            is the cardholder
                                                            charged (i.e. at
                                                            time of order, at
                                                            time of shipping,
                                                            etc.)?
                                                        </label>
                                                        <p className="form-control-static">
                                                            {appData
                                                                .powerappbusinessprofile
                                                                .cardholder_charged_desc || (
                                                                <>&mdash;</>
                                                            )}{" "}
                                                        </p>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>
                                                            If selling a
                                                            tangible product,
                                                            what is the delivery
                                                            timeframe for
                                                            products?
                                                        </label>
                                                        <p className="form-control-static">
                                                            {appData
                                                                .powerappbusinessprofile
                                                                .tangable_delivery_timeframe || (
                                                                <>&mdash;</>
                                                            )}{" "}
                                                        </p>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>
                                                            If charging for
                                                            services, how long
                                                            will it take to
                                                            complete all
                                                            services once the
                                                            card is charged?
                                                        </label>
                                                        <p className="form-control-static">
                                                            {appData
                                                                .powerappbusinessprofile
                                                                .time_to_complete_services || (
                                                                <>&mdash;</>
                                                            )}{" "}
                                                        </p>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>
                                                            Please provide an
                                                            example of a large
                                                            transaction amount,
                                                            what is included
                                                            with that purchase,
                                                            and how
                                                        </label>
                                                        <p className="form-control-static">
                                                            {appData
                                                                .powerappbusinessprofile
                                                                .ex_of_large_tranc_amt_fq_occur || (
                                                                <>&mdash;</>
                                                            )}{" "}
                                                        </p>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>
                                                            If product is sold
                                                            via website, please
                                                            provide all website
                                                            addresses associated
                                                            with the sales
                                                        </label>
                                                        <p className="form-control-static">
                                                            {appData
                                                                .powerappbusinessprofile
                                                                .if_sold_by_web_desc || (
                                                                <>&mdash;</>
                                                            )}{" "}
                                                        </p>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>
                                                            Is there any
                                                            recurring billing or
                                                            trial offers as part
                                                            of the purchase?
                                                        </label>
                                                        <p className="form-control-static">
                                                            {appData
                                                                .powerappbusinessprofile
                                                                .recurring_bill_triel_radio || (
                                                                <>&mdash;</>
                                                            )}{" "}
                                                        </p>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>
                                                            If yes, please
                                                            explain terms.
                                                        </label>
                                                        <p className="form-control-static">
                                                            {appData
                                                                .powerappbusinessprofile
                                                                .recurring_billing_triel_off_terms || (
                                                                <>&mdash;</>
                                                            )}{" "}
                                                        </p>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>
                                                            What percentage of
                                                            sales are shipped or
                                                            completed outside of
                                                            30 days?
                                                        </label>
                                                        <p className="form-control-static">
                                                            {appData
                                                                .powerappbusinessprofile
                                                                .complete_sales_outside_30 || (
                                                                <>&mdash;</>
                                                            )}{" "}
                                                        </p>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>
                                                            Please detail how
                                                            the products or
                                                            services are
                                                            advertised or
                                                            marketed? (i.e.
                                                            website, tv, radio,
                                                            call center). Please
                                                            provide a sample of
                                                            your marketing
                                                            material (brochure,
                                                            flyer, order form,
                                                            advertising script,
                                                            contracts, or
                                                            agreements)
                                                        </label>
                                                        <p className="form-control-static">
                                                            {appData
                                                                .powerappbusinessprofile
                                                                .prod_advertise_desc || (
                                                                <>&mdash;</>
                                                            )}{" "}
                                                        </p>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>
                                                            What happens if the
                                                            product is
                                                            unavailable or if
                                                            service cannot be
                                                            rendered (i.e. cease
                                                            billing customer,
                                                            issue refund, or
                                                            notify customer of a
                                                            delayed shipment?
                                                            Please explain.
                                                        </label>
                                                        <p className="form-control-static">
                                                            {appData
                                                                .powerappbusinessprofile
                                                                .product_unavailable_stage_desc || (
                                                                <>&mdash;</>
                                                            )}{" "}
                                                        </p>
                                                    </div>
                                                    <div className="form-group">
                                                        <p>
                                                            <b>
                                                                Do you
                                                                anticipate
                                                                accepting
                                                                foreign sales?
                                                            </b>
                                                        </p>
                                                        <p className="form-control-static">
                                                            {appData
                                                                .powerappbusinessprofile
                                                                .anticipate_accepting_foreign_sales_radio || (
                                                                <>&mdash;</>
                                                            )}{" "}
                                                        </p>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>
                                                            If yes, what
                                                            percentage?
                                                        </label>
                                                        <p className="form-control-static">
                                                            {appData
                                                                .powerappbusinessprofile
                                                                .anticipate_forign_sale_desc || (
                                                                <>&mdash;</>
                                                            )}{" "}
                                                        </p>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>
                                                            Is Customer Service
                                                            handled in-house or
                                                            outsourced?
                                                        </label>
                                                        <p className="form-control-static">
                                                            {appData
                                                                .powerappbusinessprofile
                                                                .customer_service_handled_radio || (
                                                                <>&mdash;</>
                                                            )}{" "}
                                                        </p>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>
                                                            Are
                                                            products/services
                                                            delivered by a third
                                                            party?
                                                        </label>
                                                        <p className="form-control-static">
                                                            {appData
                                                                .powerappbusinessprofile
                                                                .thirdparty_delivered_radio || (
                                                                <>&mdash;</>
                                                            )}{" "}
                                                        </p>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>
                                                            Who are your major
                                                            wholesalers/vendors/distributors
                                                            for your
                                                            products/services?
                                                        </label>
                                                        <p className="form-control-static">
                                                            {appData
                                                                .powerappbusinessprofile
                                                                .major_wvd || (
                                                                <>&mdash;</>
                                                            )}{" "}
                                                        </p>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>
                                                            How are terms and
                                                            conditions
                                                            associated with the
                                                            sale disclosed to
                                                            the cardholder?
                                                        </label>
                                                        <p className="form-control-static">
                                                            {appData
                                                                .powerappbusinessprofile
                                                                .condition_asso_sale_disclosed_cardholder || (
                                                                <>&mdash;</>
                                                            )}{" "}
                                                        </p>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>
                                                            What are your
                                                            customer service
                                                            hours and customer
                                                            service phone #?
                                                        </label>
                                                        <p className="form-control-static">
                                                            {appData
                                                                .powerappbusinessprofile
                                                                .customer_service_details || (
                                                                <>&mdash;</>
                                                            )}{" "}
                                                        </p>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>
                                                            Please explain the
                                                            refund and/or
                                                            cancellation
                                                            policies.
                                                        </label>
                                                        <p className="form-control-static">
                                                            {appData
                                                                .powerappbusinessprofile
                                                                .cancellation_policy_desc || (
                                                                <>&mdash;</>
                                                            )}{" "}
                                                        </p>
                                                    </div>
                                                    <div className="form-group">
                                                        <label>MCC</label>
                                                        <p className="form-control-static">
                                                            {appData.mcc_info ? (
                                                                appData.mcc_info
                                                                    .description
                                                            ) : (
                                                                <>&mdash;</>
                                                            )}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="relevent-info-box">
                                        <div className="relevent-infos card-profile">
                                            <h4 className="text-center">
                                                Business Info not Available
                                            </h4>
                                        </div>
                                    </div>
                                )}
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Card.Header
                            className={accordionNumber === 3 ? "opened" : ""}
                        >
                            <Accordion.Toggle
                                as={Button}
                                variant="link"
                                eventKey="3"
                                onClick={() => this.handleToggleAccordion(3)}
                            >
                                Credit Card Processing{" "}
                                <i
                                    className={
                                        accordionNumber === 3
                                            ? "fa fa-chevron-up"
                                            : "fa fa-chevron-down"
                                    }
                                />
                            </Accordion.Toggle>
                        </Card.Header>
                        <Accordion.Collapse eventKey="3">
                            <Card.Body>
                                <div className="relevent-info-box">
                                    {appData.creditcardprocess ? (
                                        <div className="relevent-infos card-profile">
                                            <h4 className="text-center">
                                                Credit Card Processing
                                            </h4>
                                            <div className="row">
                                                <div className="col-md-12 col-sm-12 col-xs-12">
                                                    <p>
                                                        <b>
                                                            Has the business or
                                                            any associated owner
                                                            ever been terminated
                                                            as a
                                                            Visa®MasterCard®/Discover®/American
                                                            Express® merchant?
                                                        </b>
                                                    </p>
                                                    <p>
                                                        {appData.creditcardprocess
                                                            ? appData
                                                                  .creditcardprocess
                                                                  .terminated_as_vmdax
                                                            : ""}{" "}
                                                    </p>
                                                    <p>
                                                        <b>
                                                            Do you currently
                                                            accept
                                                            Visa®/MasterCard®/Discover®/American
                                                            Express® If yes,
                                                            please submit 3 most
                                                            current monthly
                                                            statements.
                                                        </b>
                                                    </p>
                                                    <p>
                                                        {appData.creditcardprocess
                                                            ? appData
                                                                  .creditcardprocess
                                                                  .accept_vmdax
                                                            : ""}{" "}
                                                    </p>
                                                    <p>
                                                        <b>
                                                            Are the third
                                                            parties/payment
                                                            application involved
                                                            with your payment
                                                            process.
                                                        </b>
                                                    </p>
                                                    <p>
                                                        {appData.creditcardprocess
                                                            ? appData
                                                                  .creditcardprocess
                                                                  .third_party_involve
                                                            : ""}
                                                    </p>
                                                    <p>
                                                        <b>
                                                            Is your business PCI
                                                            complaint?
                                                        </b>
                                                    </p>
                                                    <p>
                                                        {appData.creditcardprocess
                                                            ? appData
                                                                  .creditcardprocess
                                                                  .pci_complaint
                                                            : ""}{" "}
                                                    </p>
                                                    <p>
                                                        <b>
                                                            Has your business
                                                            had any ongoing or
                                                            prior data
                                                            compromise
                                                            investigations?
                                                        </b>
                                                    </p>
                                                    <p>
                                                        {appData.creditcardprocess
                                                            ? appData
                                                                  .creditcardprocess
                                                                  .prior_data_compromise_invetigation
                                                            : ""}{" "}
                                                    </p>
                                                    <p>
                                                        <b>
                                                            Has the business
                                                            previously
                                                            identified with Visa
                                                            Risk Programes.
                                                        </b>
                                                    </p>
                                                    <p>
                                                        {appData.creditcardprocess
                                                            ? appData
                                                                  .creditcardprocess
                                                                  .identified_visa_risk_program
                                                            : ""}{" "}
                                                    </p>
                                                    <p>
                                                        <b>
                                                            Are you currently
                                                            processing?
                                                        </b>
                                                    </p>
                                                    <p>
                                                        {appData.creditcardprocess
                                                            ? appData
                                                                  .creditcardprocess
                                                                  .currently_processing
                                                            : ""}{" "}
                                                    </p>
                                                    <p>
                                                        <b>
                                                            How are you taking
                                                            cards?
                                                        </b>
                                                    </p>
                                                    <p>
                                                        {appData.creditcardprocess
                                                            ? appData
                                                                  .creditcardprocess
                                                                  .takingcards
                                                            : ""}{" "}
                                                    </p>
                                                </div>
                                                <div className="col-md-12 col-sm-12 col-xs-12">
                                                    <h4 className="text-center">
                                                        Bank Info
                                                    </h4>
                                                </div>
                                                <div className="col-md-6 col-sm-12 col-xs-12">
                                                    <p>
                                                        <b>Bank Name </b>:{" "}
                                                        {appData.bankinfo
                                                            ? appData.bankinfo
                                                                  .bankname
                                                            : ""}
                                                    </p>
                                                    <p>
                                                        <b>Routing Number</b> :{" "}
                                                        {appData.bankinfo
                                                            ? appData.bankinfo
                                                                  .bankrouting
                                                            : ""}
                                                    </p>
                                                    <p>
                                                        <b>Account Number</b> :{" "}
                                                        {appData.bankinfo
                                                            ? appData.bankinfo
                                                                  .bankaccount
                                                            : ""}
                                                    </p>
                                                </div>
                                                <div className="col-md-6 col-sm-12 col-xs-12">
                                                    <p>
                                                        <b>
                                                            Max monthly sales (
                                                            USD ){" "}
                                                        </b>
                                                        :{" "}
                                                        {appData.bankinfo
                                                            ? appData.bankinfo
                                                                  .maxsales
                                                            : ""}{" "}
                                                    </p>
                                                    <p>
                                                        <b>Average Ticket</b> :{" "}
                                                        {appData.bankinfo
                                                            ? appData.bankinfo
                                                                  .ticketaverage
                                                            : ""}
                                                    </p>
                                                    <p>
                                                        <b>Highest Ticket</b> :{" "}
                                                        {appData.bankinfo
                                                            ? appData.bankinfo
                                                                  .tickethighest
                                                            : ""}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="relevent-infos card-profile">
                                            <h4 className="text-center">
                                                Credit Card Processing Info not
                                                Available
                                            </h4>
                                        </div>
                                    )}
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Card.Header
                            className={accordionNumber === 4 ? "opened" : ""}
                        >
                            <Accordion.Toggle
                                as={Button}
                                variant="link"
                                eventKey="4"
                                onClick={() => this.handleToggleAccordion(4)}
                            >
                                Pricing{" "}
                                <i
                                    className={
                                        accordionNumber === 4
                                            ? "fa fa-chevron-up"
                                            : "fa fa-chevron-down"
                                    }
                                />
                            </Accordion.Toggle>
                        </Card.Header>
                        <Accordion.Collapse eventKey="4">
                            <Card.Body>
                                <div className="relevent-info-box">
                                    <div className="text-right">
                                        {appData.organization &&
                                        appData.user ? (
                                            <a
                                                href={`${MAIN_URL}${appData.organization.whitelabel_slug}/${appData.user.agent_url}/${appData.editslug}`}
                                                className="bank-btn"
                                                type="button"
                                            >
                                                Update Price
                                            </a>
                                        ) : null}
                                    </div>
                                    {appData.prices &&
                                    appData.prices.length >= 1 ? (
                                        <div className="relevent-infos card-profile">
                                            <div>
                                                <div>
                                                    <h4 className="text-center">
                                                        {this.PricingLabel(
                                                            appData.qualifiedtype,
                                                        )}
                                                    </h4>
                                                </div>
                                            </div>
                                            {appData.qualifiedtype ==
                                            "icppt" ? (
                                                <div>
                                                    <div>
                                                        <h4 className="text-center">
                                                            Processing Fees
                                                        </h4>
                                                        <div className="row">
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        Passthrough
                                                                        (per
                                                                        item){" "}
                                                                        {
                                                                            appData
                                                                                .prices[1]
                                                                                .subtitle
                                                                        }
                                                                    </b>
                                                                    :{" "}
                                                                    {
                                                                        appData
                                                                            .prices[1]
                                                                            .pivot
                                                                            .percent
                                                                    }
                                                                    %
                                                                </p>
                                                            </div>
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        Passthrough
                                                                        (per
                                                                        item){" "}
                                                                        {
                                                                            appData
                                                                                .prices[1]
                                                                                .subtitle
                                                                        }
                                                                    </b>
                                                                    : $
                                                                    {
                                                                        appData
                                                                            .prices[1]
                                                                            .pivot
                                                                            .dollars
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p className="form-control-static">
                                                                    <b>
                                                                        Pin
                                                                        Debit :{" "}
                                                                    </b>
                                                                    {
                                                                        appData.debit_pin
                                                                    }
                                                                </p>
                                                            </div>
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p className="form-control-static"></p>
                                                            </div>
                                                        </div>
                                                        {appData.debit_pin ==
                                                        "yes" ? (
                                                            <div className="row">
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            PIN
                                                                            Debit
                                                                        </b>
                                                                        :{" "}
                                                                        {
                                                                            appData
                                                                                .prices[4]
                                                                                .pivot
                                                                                .percent
                                                                        }
                                                                        %
                                                                    </p>
                                                                </div>
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            PIN
                                                                            Debit
                                                                        </b>
                                                                        : $
                                                                        {
                                                                            appData
                                                                                .prices[4]
                                                                                .pivot
                                                                                .dollars
                                                                        }
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        ) : null}
                                                        <div className="row">
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        Signature
                                                                        Debit
                                                                    </b>
                                                                    :{" "}
                                                                    {
                                                                        appData
                                                                            .prices[5]
                                                                            .pivot
                                                                            .percent
                                                                    }
                                                                    %
                                                                </p>
                                                            </div>
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        Signature
                                                                        Debit
                                                                    </b>
                                                                    : $
                                                                    {
                                                                        appData
                                                                            .prices[5]
                                                                            .pivot
                                                                            .dollars
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <h4 className="text-center">
                                                            General fees
                                                        </h4>
                                                        <div>
                                                            <div className="row">
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            Service
                                                                            (Monthly)
                                                                        </b>
                                                                        : $
                                                                        {
                                                                            appData
                                                                                .prices[16]
                                                                                .pivot
                                                                                .dollars
                                                                        }
                                                                    </p>
                                                                </div>
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            Authorization
                                                                            (Per
                                                                            Item)
                                                                        </b>
                                                                        : $
                                                                        {
                                                                            appData
                                                                                .prices[10]
                                                                                .pivot
                                                                                .dollars
                                                                        }
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            Batch
                                                                            Header
                                                                            (Per
                                                                            Batch)
                                                                        </b>
                                                                        : $
                                                                        {
                                                                            appData
                                                                                .prices[13]
                                                                                .pivot
                                                                                .dollars
                                                                        }
                                                                    </p>
                                                                </div>
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            Voice
                                                                            Authorization
                                                                            (Per
                                                                            Item)
                                                                        </b>
                                                                        : $
                                                                        {
                                                                            appData
                                                                                .prices[11]
                                                                                .pivot
                                                                                .dollars
                                                                        }
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            Chargeback
                                                                            (Per
                                                                            Item)
                                                                        </b>
                                                                        : $
                                                                        {
                                                                            appData
                                                                                .prices[19]
                                                                                .pivot
                                                                                .dollars
                                                                        }
                                                                    </p>
                                                                </div>
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            Retrieval
                                                                            (Per
                                                                            Item)
                                                                        </b>
                                                                        : $
                                                                        {
                                                                            appData
                                                                                .prices[20]
                                                                                .pivot
                                                                                .dollars
                                                                        }
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            NSF/ACH
                                                                            Reject
                                                                            (Per
                                                                            Item)
                                                                        </b>
                                                                        : $
                                                                        {
                                                                            appData
                                                                                .prices[21]
                                                                                .pivot
                                                                                .dollars
                                                                        }
                                                                    </p>
                                                                </div>
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            Monthly
                                                                            Minimum
                                                                            (minimum
                                                                            discount)
                                                                        </b>
                                                                        : $
                                                                        {
                                                                            appData
                                                                                .prices[17]
                                                                                .pivot
                                                                                .dollars
                                                                        }
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            Annual
                                                                            Fee
                                                                        </b>
                                                                        : $
                                                                        {
                                                                            appData
                                                                                .prices[24]
                                                                                .pivot
                                                                                .dollars
                                                                        }
                                                                    </p>
                                                                </div>
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            {" "}
                                                                            Early
                                                                            closure
                                                                            (ETF)
                                                                        </b>
                                                                        : $
                                                                        {
                                                                            appData
                                                                                .prices[26]
                                                                                .pivot
                                                                                .dollars
                                                                        }
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            AVS
                                                                            Fee
                                                                        </b>
                                                                        : $
                                                                        {
                                                                            appData
                                                                                .prices[12]
                                                                                .pivot
                                                                                .dollars
                                                                        }
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <h4 className="text-center">
                                                            EBT Fees
                                                        </h4>
                                                        <div className="row">
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        Does
                                                                        Merchant
                                                                        Accept
                                                                        EBT :{" "}
                                                                    </b>
                                                                    {
                                                                        appData.ebt_fees
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                        {appData.ebt_fees ===
                                                            "yes" && (
                                                            <div>
                                                                <div className="row">
                                                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                                                        <p
                                                                            className={
                                                                                "form-control-static "
                                                                            }
                                                                        >
                                                                            <b>
                                                                                EBT
                                                                                Transactions
                                                                                (Per
                                                                                Item)
                                                                            </b>
                                                                            : $
                                                                            {
                                                                                appData
                                                                                    .prices[28]
                                                                                    .pivot
                                                                                    .dollars
                                                                            }
                                                                        </p>
                                                                    </div>
                                                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                                                        <p
                                                                            className={
                                                                                "form-control-static "
                                                                            }
                                                                        >
                                                                            <b>
                                                                                {" "}
                                                                                EBT
                                                                                Transaction
                                                                                (Monthly)
                                                                            </b>
                                                                            : $
                                                                            {
                                                                                appData
                                                                                    .prices[29]
                                                                                    .pivot
                                                                                    .dollars
                                                                            }
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                                                        <p
                                                                            className={
                                                                                "form-control-static "
                                                                            }
                                                                        >
                                                                            <b>
                                                                                EBT
                                                                                Reg
                                                                                Number
                                                                            </b>
                                                                            : $
                                                                            {
                                                                                appData
                                                                                    .prices[30]
                                                                                    .pivot
                                                                                    .dollars
                                                                            }
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                        <h4 className="text-center">
                                                            American Express
                                                        </h4>
                                                        <div className="row">
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        Opt out
                                                                        from
                                                                        American
                                                                        Express?
                                                                        :{" "}
                                                                    </b>
                                                                    {
                                                                        appData.apexoptout
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {appData.apexoptout ===
                                                        "no" && (
                                                        <div className="row">
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        Passthrough
                                                                        (Per
                                                                        Item)
                                                                    </b>
                                                                    :{" "}
                                                                    {
                                                                        appData
                                                                            .prices[34]
                                                                            .pivot
                                                                            .percent
                                                                    }
                                                                    %
                                                                </p>
                                                            </div>
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        Passthrough
                                                                        (Per
                                                                        Item)
                                                                    </b>
                                                                    : $
                                                                    {
                                                                        appData
                                                                            .prices[34]
                                                                            .pivot
                                                                            .dollars
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            ) : null}
                                            {appData.qualifiedtype ==
                                            "tiered" ? (
                                                <div>
                                                    <div>
                                                        <h4 className="text-center">
                                                            Processing Fees
                                                        </h4>
                                                        <div className="row">
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        Qualified-tiered
                                                                        (Per
                                                                        Item)
                                                                    </b>
                                                                    :{" "}
                                                                    {
                                                                        appData
                                                                            .prices[0]
                                                                            .pivot
                                                                            .percent
                                                                    }
                                                                    %
                                                                </p>
                                                            </div>
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        Qualified-tiered
                                                                        (Per
                                                                        Item)
                                                                    </b>
                                                                    : $
                                                                    {
                                                                        appData
                                                                            .prices[0]
                                                                            .pivot
                                                                            .dollars
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        Mid-tiered
                                                                        (Per
                                                                        item)
                                                                    </b>
                                                                    :{" "}
                                                                    {
                                                                        appData
                                                                            .prices[2]
                                                                            .pivot
                                                                            .percent
                                                                    }
                                                                    %
                                                                </p>
                                                            </div>
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        Mid-tiered
                                                                        (Per
                                                                        item)
                                                                    </b>
                                                                    : $
                                                                    {
                                                                        appData
                                                                            .prices[2]
                                                                            .pivot
                                                                            .dollars
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        Non-tiered
                                                                        (Per
                                                                        Item)
                                                                    </b>
                                                                    :{" "}
                                                                    {
                                                                        appData
                                                                            .prices[3]
                                                                            .pivot
                                                                            .percent
                                                                    }
                                                                    %
                                                                </p>
                                                            </div>
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        Non-tiered
                                                                        (Per
                                                                        Item)
                                                                    </b>
                                                                    : $
                                                                    {
                                                                        appData
                                                                            .prices[3]
                                                                            .pivot
                                                                            .dollars
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <h4 className="text-center">
                                                            Pin Debit
                                                        </h4>
                                                        <div className="row">
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        Pin
                                                                        Debit :{" "}
                                                                    </b>
                                                                    {
                                                                        appData.debit_pin
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                        {appData.debit_pin ==
                                                        "yes" ? (
                                                            <div className="row">
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            PIN
                                                                            Debit
                                                                        </b>
                                                                        :{" "}
                                                                        {
                                                                            appData
                                                                                .prices[4]
                                                                                .pivot
                                                                                .percent
                                                                        }
                                                                        %
                                                                    </p>
                                                                </div>
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            PIN
                                                                            Debit
                                                                        </b>
                                                                        : $
                                                                        {
                                                                            appData
                                                                                .prices[4]
                                                                                .pivot
                                                                                .dollars
                                                                        }
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        ) : null}
                                                        <div className="row">
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        Signature
                                                                        Debit
                                                                    </b>
                                                                    :{" "}
                                                                    {
                                                                        appData
                                                                            .prices[5]
                                                                            .pivot
                                                                            .percent
                                                                    }
                                                                    %
                                                                </p>
                                                            </div>
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        Signature
                                                                        Debit
                                                                    </b>
                                                                    : $
                                                                    {
                                                                        appData
                                                                            .prices[5]
                                                                            .pivot
                                                                            .dollars
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <h4 className="text-center">
                                                            General fees
                                                        </h4>
                                                        <div>
                                                            <div className="row">
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            Service
                                                                            (Monthly)
                                                                        </b>
                                                                        : $
                                                                        {
                                                                            appData
                                                                                .prices[16]
                                                                                .pivot
                                                                                .dollars
                                                                        }
                                                                    </p>
                                                                </div>
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            Authorization
                                                                            (Per
                                                                            Item)
                                                                        </b>
                                                                        : $
                                                                        {
                                                                            appData
                                                                                .prices[10]
                                                                                .pivot
                                                                                .dollars
                                                                        }
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            Batch
                                                                            Header
                                                                            (Per
                                                                            Batch)
                                                                        </b>
                                                                        : $
                                                                        {
                                                                            appData
                                                                                .prices[13]
                                                                                .pivot
                                                                                .dollars
                                                                        }
                                                                    </p>
                                                                </div>
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            Voice
                                                                            Authorization
                                                                            (Per
                                                                            Item)
                                                                        </b>
                                                                        : $
                                                                        {
                                                                            appData
                                                                                .prices[11]
                                                                                .pivot
                                                                                .dollars
                                                                        }
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            Chargeback
                                                                            (Per
                                                                            Item)
                                                                        </b>
                                                                        : $
                                                                        {
                                                                            appData
                                                                                .prices[19]
                                                                                .pivot
                                                                                .dollars
                                                                        }
                                                                    </p>
                                                                </div>
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            Retrieval
                                                                            (Per
                                                                            Item)
                                                                        </b>
                                                                        : $
                                                                        {
                                                                            appData
                                                                                .prices[20]
                                                                                .pivot
                                                                                .dollars
                                                                        }
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            NSF/ACH
                                                                            Reject
                                                                            (Per
                                                                            Item)
                                                                        </b>
                                                                        : $
                                                                        {
                                                                            appData
                                                                                .prices[21]
                                                                                .pivot
                                                                                .dollars
                                                                        }
                                                                    </p>
                                                                </div>
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            Monthly
                                                                            Minimum
                                                                            (minimum
                                                                            discount)
                                                                        </b>
                                                                        : $
                                                                        {
                                                                            appData
                                                                                .prices[17]
                                                                                .pivot
                                                                                .dollars
                                                                        }
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            Annual
                                                                            Fee
                                                                        </b>
                                                                        : $
                                                                        {
                                                                            appData
                                                                                .prices[24]
                                                                                .pivot
                                                                                .dollars
                                                                        }
                                                                    </p>
                                                                </div>
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            {" "}
                                                                            Early
                                                                            closure
                                                                            (ETF)
                                                                        </b>
                                                                        : $
                                                                        {
                                                                            appData
                                                                                .prices[26]
                                                                                .pivot
                                                                                .dollars
                                                                        }
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            AVS
                                                                            Fee
                                                                        </b>
                                                                        : $
                                                                        {
                                                                            appData
                                                                                .prices[12]
                                                                                .pivot
                                                                                .dollars
                                                                        }
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <h4 className="text-center">
                                                            EBT Fees
                                                        </h4>
                                                        <div className="row">
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        Does
                                                                        Merchant
                                                                        Accept
                                                                        EBT :{" "}
                                                                    </b>
                                                                    {
                                                                        appData.ebt_fees
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                        {appData.ebt_fees ===
                                                            "yes" && (
                                                            <div>
                                                                <div className="row">
                                                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                                                        <p
                                                                            className={
                                                                                "form-control-static "
                                                                            }
                                                                        >
                                                                            <b>
                                                                                EBT
                                                                                Transactions
                                                                                (Per
                                                                                Item)
                                                                            </b>
                                                                            : $
                                                                            {
                                                                                appData
                                                                                    .prices[28]
                                                                                    .pivot
                                                                                    .dollars
                                                                            }
                                                                        </p>
                                                                    </div>
                                                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                                                        <p
                                                                            className={
                                                                                "form-control-static "
                                                                            }
                                                                        >
                                                                            <b>
                                                                                {" "}
                                                                                EBT
                                                                                Transaction
                                                                                (Monthly)
                                                                            </b>
                                                                            : $
                                                                            {
                                                                                appData
                                                                                    .prices[29]
                                                                                    .pivot
                                                                                    .dollars
                                                                            }
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                                                        <p
                                                                            className={
                                                                                "form-control-static "
                                                                            }
                                                                        >
                                                                            <b>
                                                                                EBT
                                                                                Reg
                                                                                Number
                                                                            </b>
                                                                            : $
                                                                            {
                                                                                appData
                                                                                    .prices[30]
                                                                                    .pivot
                                                                                    .dollars
                                                                            }
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                        <h4 className="text-center">
                                                            American Express
                                                        </h4>
                                                        <div className="row">
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        Opt out
                                                                        from
                                                                        American
                                                                        Express?
                                                                        :{" "}
                                                                    </b>
                                                                    {
                                                                        appData.apexoptout
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {appData.apexoptout ===
                                                        "no" && (
                                                        <div>
                                                            <div className="row">
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            {
                                                                                "Tier 1 (<$150)"
                                                                            }{" "}
                                                                        </b>
                                                                        :{" "}
                                                                        {
                                                                            appData
                                                                                .prices[31]
                                                                                .pivot
                                                                                .percent
                                                                        }
                                                                        %
                                                                    </p>
                                                                </div>
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            {
                                                                                "Tier 1 (<$150)"
                                                                            }{" "}
                                                                        </b>
                                                                        : $
                                                                        {
                                                                            appData
                                                                                .prices[31]
                                                                                .pivot
                                                                                .dollars
                                                                        }
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            {
                                                                                "Tier 2 ($150 - $3,000)"
                                                                            }{" "}
                                                                        </b>
                                                                        :{" "}
                                                                        {
                                                                            appData
                                                                                .prices[32]
                                                                                .pivot
                                                                                .percent
                                                                        }
                                                                        %
                                                                    </p>
                                                                </div>
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            {
                                                                                "Tier 2 ($150 - $3,000)"
                                                                            }
                                                                        </b>
                                                                        : $
                                                                        {
                                                                            appData
                                                                                .prices[32]
                                                                                .pivot
                                                                                .dollars
                                                                        }
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            {
                                                                                "Tier 3 (>$3,000)"
                                                                            }
                                                                        </b>
                                                                        :{" "}
                                                                        {
                                                                            appData
                                                                                .prices[33]
                                                                                .pivot
                                                                                .percent
                                                                        }
                                                                        %
                                                                    </p>
                                                                </div>
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            {
                                                                                "Tier 3 (>$3,000)"
                                                                            }
                                                                        </b>
                                                                        : $
                                                                        {
                                                                            appData
                                                                                .prices[33]
                                                                                .pivot
                                                                                .dollars
                                                                        }
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            ) : null}
                                            {appData.qualifiedtype == "sccd" ? (
                                                <div>
                                                    <div>
                                                        <div className="row">
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        {
                                                                            "Discount Rate (Per Transaction)"
                                                                        }{" "}
                                                                    </b>
                                                                    :{" "}
                                                                    {
                                                                        appData
                                                                            .prices[34]
                                                                            .pivot
                                                                            .percent
                                                                    }
                                                                    %
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <h4 className="text-center">
                                                            Pin Debit
                                                        </h4>
                                                        <div className="row">
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        Pin
                                                                        Debit :{" "}
                                                                    </b>
                                                                    {
                                                                        appData.debit_pin
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                        {appData.debit_pin ==
                                                        "yes" ? (
                                                            <div className="row">
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            PIN
                                                                            Debit
                                                                        </b>
                                                                        :{" "}
                                                                        {
                                                                            appData
                                                                                .prices[4]
                                                                                .pivot
                                                                                .percent
                                                                        }
                                                                        %
                                                                    </p>
                                                                </div>
                                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                                    <p
                                                                        className={
                                                                            "form-control-static "
                                                                        }
                                                                    >
                                                                        <b>
                                                                            PIN
                                                                            Debit
                                                                        </b>
                                                                        : $
                                                                        {
                                                                            appData
                                                                                .prices[4]
                                                                                .pivot
                                                                                .dollars
                                                                        }
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                    <h4 className="text-center">
                                                        General fees
                                                    </h4>
                                                    <div>
                                                        <div className="row">
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        Service
                                                                        (Monthly)
                                                                    </b>
                                                                    : $
                                                                    {
                                                                        appData
                                                                            .prices[16]
                                                                            .pivot
                                                                            .dollars
                                                                    }
                                                                </p>
                                                            </div>
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        Authorization
                                                                        (Per
                                                                        Item)
                                                                    </b>
                                                                    : $
                                                                    {
                                                                        appData
                                                                            .prices[10]
                                                                            .pivot
                                                                            .dollars
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        Batch
                                                                        Header
                                                                        (Per
                                                                        Batch)
                                                                    </b>
                                                                    : $
                                                                    {
                                                                        appData
                                                                            .prices[13]
                                                                            .pivot
                                                                            .dollars
                                                                    }
                                                                </p>
                                                            </div>
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        Voice
                                                                        Authorization
                                                                        (Per
                                                                        Item)
                                                                    </b>
                                                                    : $
                                                                    {
                                                                        appData
                                                                            .prices[11]
                                                                            .pivot
                                                                            .dollars
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        Chargeback
                                                                        (Per
                                                                        Item)
                                                                    </b>
                                                                    : $
                                                                    {
                                                                        appData
                                                                            .prices[19]
                                                                            .pivot
                                                                            .dollars
                                                                    }
                                                                </p>
                                                            </div>
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        Retrieval
                                                                        (Per
                                                                        Item)
                                                                    </b>
                                                                    : $
                                                                    {
                                                                        appData
                                                                            .prices[20]
                                                                            .pivot
                                                                            .dollars
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        NSF/ACH
                                                                        Reject
                                                                        (Per
                                                                        Item)
                                                                    </b>
                                                                    : $
                                                                    {
                                                                        appData
                                                                            .prices[21]
                                                                            .pivot
                                                                            .dollars
                                                                    }
                                                                </p>
                                                            </div>
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        Monthly
                                                                        Minimum
                                                                        (minimum
                                                                        discount)
                                                                    </b>
                                                                    : $
                                                                    {
                                                                        appData
                                                                            .prices[17]
                                                                            .pivot
                                                                            .dollars
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        Annual
                                                                        Fee
                                                                    </b>
                                                                    : $
                                                                    {
                                                                        appData
                                                                            .prices[24]
                                                                            .pivot
                                                                            .dollars
                                                                    }
                                                                </p>
                                                            </div>
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        {" "}
                                                                        Early
                                                                        closure
                                                                        (ETF)
                                                                    </b>
                                                                    : $
                                                                    {
                                                                        appData
                                                                            .prices[26]
                                                                            .pivot
                                                                            .dollars
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                                <p
                                                                    className={
                                                                        "form-control-static "
                                                                    }
                                                                >
                                                                    <b>
                                                                        AVS Fee
                                                                    </b>
                                                                    : $
                                                                    {
                                                                        appData
                                                                            .prices[12]
                                                                            .pivot
                                                                            .dollars
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : null}
                                        </div>
                                    ) : (
                                        <div className="relevent-infos card-profile">
                                            <h4 className="text-center">
                                                Pricing Info not Available
                                            </h4>
                                        </div>
                                    )}
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Card.Header
                            className={accordionNumber === 5 ? "opened" : ""}
                        >
                            <Accordion.Toggle
                                as={Button}
                                variant="link"
                                eventKey="5"
                                onClick={() => this.handleToggleAccordion(5)}
                            >
                                Equipment{" "}
                                <i
                                    className={
                                        accordionNumber === 5
                                            ? "fa fa-chevron-up"
                                            : "fa fa-chevron-down"
                                    }
                                />
                            </Accordion.Toggle>
                        </Card.Header>
                        <Accordion.Collapse eventKey="5">
                            <Card.Body>
                                <div className="relevent-info-box">
                                    {appData.powerappequipment &&
                                    appData.powerappequipment != null ? (
                                        <div className="relevent-infos card-profile">
                                            <h4 className="text-center">
                                                Equipment Info
                                            </h4>
                                            <div className="row">
                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                    <p>
                                                        <b>Equipment Option</b>:{" "}
                                                        {
                                                            appData
                                                                .powerappequipment
                                                                .equipment_option
                                                        }
                                                    </p>
                                                </div>
                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                    <p>
                                                        <b>Gateway Option</b>:{" "}
                                                        {
                                                            appData
                                                                .powerappequipment
                                                                .gateway_option
                                                        }
                                                    </p>
                                                </div>
                                                {appData.powerappequipment
                                                    .equipment_option ==
                                                    "terminal" && (
                                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                                        <p>
                                                            <b>Terminal Name</b>
                                                            :{" "}
                                                            {
                                                                appData
                                                                    .powerappequipment
                                                                    .equipment_type
                                                            }
                                                        </p>
                                                    </div>
                                                )}
                                                {appData.powerappequipment
                                                    .equipment_option ==
                                                    "gateway" && (
                                                    <div className="col-md-6 col-sm-6 col-xs-6">
                                                        <p>
                                                            <b>Gateway Name</b>:{" "}
                                                            {
                                                                appData
                                                                    .powerappequipment
                                                                    .equipment_type
                                                            }
                                                        </p>
                                                    </div>
                                                )}
                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                    <p>
                                                        <b>
                                                            Special Instruction
                                                        </b>
                                                        :{" "}
                                                        {
                                                            appData
                                                                .powerappequipment
                                                                .special_instruction
                                                        }
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="relevent-infos card-profile">
                                            <h4 className="text-center">
                                                Equipment Info not Available
                                            </h4>
                                        </div>
                                    )}
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            </>
        );
    }
}
